module.exports = {"version":"1.8.6","platform":"external","apiUrl":"https://api.sunfig.solar/stage","env":"stage"};